import { TenantIds } from '@config/tenant-id';
import { DefaultIcon, EnumSelect } from '@summit/core';
import { UserExperience } from '../../shared/user-experience';

export enum TimeOffType {
  None = 0,
  Vacation = 1,
  Sick = 2,
  Personal = 3,
  Holiday = 4,
  Unpaid = 5,
  Unexcused = 6,
  ProfDevelopment = 7,
  ScheduleRequest = 8,
  DeathInFamily = 9,
  NoShow = 10,
  MilitaryService = 11
}

export function GetTimeOffTypes(ux: UserExperience, driverOnly: boolean): number[] {
  switch (ux.activeEmployee.tenantID.toUpperCase()) {
    case TenantIds.KTI:
      //allow personal days for both
      return driverOnly
        ? EnumSelect.ToIdListExclude(
            TimeOffType,
            TimeOffTypesDriverExclude.filter((x) => x !== TimeOffType.Personal)
          )
        : EnumSelect.ToIdListExclude(
            TimeOffType,
            TimeOffTypesManagerExclude.filter((x) => x !== TimeOffType.Personal)
          );
    default:
      return driverOnly
        ? EnumSelect.ToIdListExclude(TimeOffType, TimeOffTypesDriverExclude)
        : EnumSelect.ToIdListExclude(TimeOffType, TimeOffTypesManagerExclude);
  }
}

export const TimeOffTypesManagerExclude = [TimeOffType.None, TimeOffType.Personal, TimeOffType.Holiday];

export const TimeOffTypesDriverExclude = [
  TimeOffType.None,
  TimeOffType.Personal,
  TimeOffType.Holiday,
  TimeOffType.Unexcused,
  TimeOffType.DeathInFamily,
  TimeOffType.NoShow,
  TimeOffType.Sick
];

export const TimeOffTypeMapping: Record<TimeOffType, string> = {
  [TimeOffType.None]: 'None',
  [TimeOffType.Vacation]: 'Vacation',
  [TimeOffType.Sick]: 'Sick',
  [TimeOffType.Personal]: 'Personal Day',
  [TimeOffType.Holiday]: 'Holiday',
  [TimeOffType.Unpaid]: 'Unpaid',
  [TimeOffType.Unexcused]: 'Unexcused',
  [TimeOffType.ProfDevelopment]: 'Prof. Development',
  [TimeOffType.ScheduleRequest]: 'Schedule Request',
  [TimeOffType.DeathInFamily]: 'Death in Family',
  [TimeOffType.NoShow]: 'No Show',
  [TimeOffType.MilitaryService]: 'Military Service'
};

//Temp until rework schedule
export const TimeOffTypeScheduleIconMapping: Record<TimeOffType, string> = {
  [TimeOffType.None]: 'none',
  [TimeOffType.Vacation]: 'vacation',
  [TimeOffType.Sick]: 'sick',
  [TimeOffType.Personal]: 'personal',
  [TimeOffType.Holiday]: 'holiday',
  [TimeOffType.Unpaid]: 'unpaid',
  [TimeOffType.Unexcused]: 'unexcused',
  [TimeOffType.ProfDevelopment]: 'prof-development',
  [TimeOffType.ScheduleRequest]: 'schedule-request',
  [TimeOffType.DeathInFamily]: 'death-in-family',
  [TimeOffType.NoShow]: 'no-show',
  [TimeOffType.MilitaryService]: 'military-tech'
};

//also need to update calendar component
export const TimeOffTypeIconMapping: Record<TimeOffType, DefaultIcon> = {
  [TimeOffType.None]: DefaultIcon.None,
  [TimeOffType.Vacation]: DefaultIcon.Vacation,
  [TimeOffType.Sick]: DefaultIcon.Sick,
  [TimeOffType.Personal]: DefaultIcon.Personal,
  [TimeOffType.Holiday]: DefaultIcon.Holiday,
  [TimeOffType.Unpaid]: DefaultIcon.Unpaid,
  [TimeOffType.Unexcused]: DefaultIcon.Unexcused,
  [TimeOffType.ProfDevelopment]: DefaultIcon.ProfDevelopment,
  [TimeOffType.ScheduleRequest]: DefaultIcon.ScheduleRequest,
  [TimeOffType.DeathInFamily]: DefaultIcon.DeathInFamily,
  [TimeOffType.NoShow]: DefaultIcon.Missing,
  [TimeOffType.MilitaryService]: DefaultIcon.Military
};
